module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tab', {
    attrs: {
      "items": _vm.tabItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beforeTxt),
      expression: "beforeTxt"
    }],
    staticClass: "layui-textarea",
    attrs: {
      "placeholder": "待处理字符串...",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.beforeTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.beforeTxt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('v-button', {
    on: {
      "click": function($event) {
        _vm.addRule()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "layui-icon"
  }, [_vm._v(" ")]), _vm._v("添加规则")])])], 1), _vm._v(" "), _vm._l((_vm.ruleA), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "layui-form-item layui-form-text "
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ruleA[index]),
        expression: "ruleA[index]"
      }],
      staticClass: "layui-input",
      staticStyle: {
        "width": "40%",
        "float": "left"
      },
      attrs: {
        "placeholder": "替换字符串/规则"
      },
      domProps: {
        "value": (_vm.ruleA[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.ruleA, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "height": "38px",
        "line-height": "38px",
        "float": "left"
      }
    }, [_vm._v("→_→")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ruleB[index]),
        expression: "ruleB[index]"
      }],
      staticClass: "layui-input",
      staticStyle: {
        "width": "40%",
        "float": "left"
      },
      attrs: {
        "type": "text",
        "placeholder": "替换字符串"
      },
      domProps: {
        "value": (_vm.ruleB[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.ruleB, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "layui-icon editicon",
      on: {
        "click": function($event) {
          _vm.removeRule(index)
        }
      }
    }, [_vm._v("")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('v-button', {
    on: {
      "click": function($event) {
        _vm.replaceTxt()
      }
    }
  }, [_c('span', [_vm._v("替换\n          "), _c('i', {
    staticClass: "layui-icon"
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('v-button', {
    on: {
      "click": function($event) {
        _vm.saveData()
      }
    }
  }, [_c('span', [_vm._v("保存数据\n          "), _c('i', {
    staticClass: "layui-icon"
  }, [_vm._v(" ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.afterTxt),
      expression: "afterTxt"
    }],
    staticClass: "layui-textarea",
    attrs: {
      "placeholder": "处理后字符串...",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.afterTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.afterTxt = $event.target.value
      }
    }
  })])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d2bce52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/strsplit.vue
// module id = 594
// module chunks = 2